import React from "react";
import {connect} from "react-redux";
import {TIPO_CONVERSACION} from "../../_helpers";
import {Button, Modal} from "react-bootstrap";
import {ConsultaModal} from "./utils/ConsultaModal";

class SobreNosotros extends React.Component {
    state = {
        appName: process.env.PUBLIC_URL,
        vendedor: {},
    };

    componentDidMount() {
    }

    abrirModalMensaje = () => {
        this.setState({showConsulta: true});
    }

    handleClose = () => {
        this.setState({showConsulta: false});
    };

    render() {
        const {} = this.state;

        return (
            <>
                <div className="container__dap my-5">
                    <h2>Sobre Nosotros</h2>

                    <div className="dap-container">
                        <div className="dap__about">
                            <p>
                                Somos un equipo de expertos en tecnología y la industria automotriz que desarrolló una
                                marketplace exclusivo para autopartistas oficiales RUDAC en Argentina.

                            </p>
                            <p>
                                Con experiencia en ingeniería, software y comercio, garantizamos una user experience
                                segura y transparente, sin comisiones ocultas ni riesgos. Nuestra plataforma conecta a
                                compradores con proveedores confiables, asegurando transacciones ágiles y 100%
                                verificadas.
                            </p>
                            <p>
                                Ante cualquier consulta:<br/>
                                <Button
                                    className="button"
                                    type="button"
                                    data-type="complementary"
                                    onClick={(e) => this.abrirModalMensaje()}
                                >
                                    ¡Envianos un mensaje!
                                </Button>
                            </p>


                        </div>
                    </div>
                </div>

                <Modal
                    size="md"
                    show={this.state.showConsulta}
                    onHide={this.handleClose}
                >
                    <Modal.Header closeButton>Envianos un mensaje</Modal.Header>
                    <Modal.Body>
                        <ConsultaModal
                            handleClose={this.handleClose}
                            type={TIPO_CONVERSACION.GENERAL}
                        />
                    </Modal.Body>
                </Modal>
            </>

        );
    }
}

function mapState(state) {
    //const {producto} = state.busqueda;
    return {};
}

const actionCreators = {};

const connectedSobreNosotros = connect(mapState, actionCreators)(SobreNosotros);
export {connectedSobreNosotros as SobreNosotros};
